<template>
  <div class="firewall-page-wrap">
    <div class="tip">
      抱歉，该内容无法在网页端观看，请您使用电脑桌面端或手机移动端app学习
    </div>
    <div class="btn desktop">
      <div @click="runApp">使用电脑桌面端</div>
    </div>

    <!-- 唤起客户端测试 -->
    <div v-if="false" class="btn desktop">
      <div @click="runAppTest">使用电脑桌面端-test- {{ status }}</div>
    </div>

    <div class="btn download">
      <div @click="download">下载软件</div>
    </div>
  </div>
</template>

<script>
import { getHomepage } from "@saas/service-api/src/layout";
import protocolCheck from "@saas/components/src/utils/protocol-check";
const protocol = process.env.VUE_APP_DESKTOP_PROTOCAL || 'comettech://';
export default {
  data: function () {
    return {
      layout: {},
      timer: null,
      status: "未尝试唤醒",
      pollingInterval: null,
    };
  },
  mounted() {
    this.apiGetHomepage();
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    apiGetHomepage() {
      let params = {};
      if (this.$route.query.preview) {
        params.preview = 1;
      }
      getHomepage(params).then((res) => {
        if (res.code === 1) {
          this.layout = res.data || {};
        } else {
          this.$message.error(res.message);
        }
      });
    },
    download() {
      this.$router.push("/download");
    },
    openAppOrAlert(appScheme) {
      return new Promise((resolve, reject) => {
        // 构建尝试打开应用的URL
        const url = appScheme;
        // 创建一个隐藏的iframe来尝试导航到该URL
        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = url;
        document.body.appendChild(iframe);

        // 设置一个定时器来检查iframe的加载状态
        this.timer = setTimeout(() => {
          if (
            iframe.contentWindow.location.href === "about:blank" ||
            iframe.contentWindow.document.readyState === "uninitialized"
          ) {
            // 如果iframe的加载状态没有改变，可能意味着应用没有打开，移除iframe并提示用户
            document.body.removeChild(iframe);
            reject();
          } else {
            // 如果成功，也可以选择移除iframe，根据实际情况调整
            document.body.removeChild(iframe);
            resolve();
          }
        }, 5000); // 假设2秒
      });
    },
    runApp() {
      const courseId = this.$route.params.courseId;
      protocolCheck(protocol + "openpage/course-detail/" + courseId, () => {
        this.download();
      });
      //   this.openAppOrAlert(protocol + "openpage/course-detail/" + courseId)
      //     .then((res) => {})
      //     .catch((res) => {
      //       this.download();
      //     });
    },
    pollServer() {
      const callbackName = `callback_${Date.now()}`;
      const script = document.createElement("script");
      script.src = `http://localhost:18188/api/invoker/check?callback=${callbackName}&openpage=/teacher`;
      window[callbackName] = (response) => {
        console.log("response", response);
        if (response.status === 1) {
          clearInterval(this.pollingInterval);
          this.status = "唤醒成功";
          // 移除全局函数
          delete window[callbackName];
        }
      };
      document.body.appendChild(script);
      // 移除脚本元素
      script.onload = () => {
        document.body.removeChild(script);
      };
    },
    runAppTest() {
      this.status = "正在唤醒本地应用...";
      window.location.href = protocol + "openpage/teacher";
      // 开始轮询
      this.pollingInterval = setInterval(() => {
        this.pollServer();
      }, 1000);

      // 设定轮询超时时间
      setTimeout(() => {
        if (this.status === "正在唤醒本地应用...") {
          clearInterval(this.pollingInterval);
          this.status = "唤醒失败";
        }
      }, 10000);
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.firewall-page-wrap {
  width: 100%;
  min-height: calc(100vh - 300px);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .tip {
    font-size: 18px;
    color: $text-color-secondary;
  }
  .btn {
    div {
      cursor: pointer;
      display: inline-block;
      padding: 5px 10px;
      border-radius: 4px;
    }
  }
  .desktop {
    margin-top: 20px;
    div {
      background: $info-color;
      color: $btn-primary-color;
    }
  }
  .download {
    margin-top: 20px;
    color: $text-color-secondary;
  }
}

// 适配
@media (max-width: 1200px) {
  .home-content {
    width: 100%;
    padding: 0.2rem;
  }
}

@media (max-width: 767px) {
  .home-page-wrap {
    .home-content > div {
      margin-bottom: 0.53rem;
    }
  }
}
</style>
